import { LuminosityContrastFilter } from "../../../operations/filters/luminosityContrast.js";
import { GLProgram } from "../../../program.js";
export class LuminosityContrastProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/luminosityContrast/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/luminosityContrast/fragment.glsl');
        var result = new LuminosityContrastProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['luminosity'] = gl.getUniformLocation(result._program, 'u_luminosity');
        result._uniforms['contrast'] = gl.getUniformLocation(result._program, 'u_contrast');
        result._uniforms['radius'] = gl.getUniformLocation(result._program, 'u_radius');
        result._uniforms['advanced'] = gl.getUniformLocation(result._program, 'u_advanced');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        return result;
    }

    setUniforms(parameters: LuminosityContrastFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        var luminosity = 1;
        var delta: number;
        if (parameters.luminosity < 0) {
            delta = -parameters.minLuminosity;
            luminosity = (parameters.luminosity - parameters.minLuminosity) / delta;
        } else {
            delta = parameters.maxLuminosity;
            luminosity = 1.0 + (parameters.luminosity) * 3 / delta;
        }
        self._gl.uniform1f(self.uniformLocation('luminosity'), luminosity);

        var contrast = 1;
        if (parameters.contrast < 0) {
            delta = -parameters.minContrast;
            if (parameters.advanced) {
                contrast = 0.3 + (parameters.contrast - parameters.minContrast) * 0.7 / delta;
            } else {
                contrast = 0.9 + (parameters.contrast - parameters.minContrast) * 0.1 / delta;
            }
        } else {
            delta = parameters.maxContrast;
            if (parameters.advanced) {
                contrast = 1.0 + (parameters.contrast) * 3.0 / delta;
            } else {
                contrast = 1.0 + (parameters.contrast) * 0.3 / delta;
            }
        }
        self._gl.uniform1f(self.uniformLocation('contrast'), contrast);
        self._gl.uniform1f(self.uniformLocation('radius'), parameters.radius);
        self._gl.uniform1i(self.uniformLocation('advanced'), parameters.advanced);
    }

}